import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Moon5am = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.08532 4.55756C4.17057 3.01097 5.9673 2 8.00015 2C11.3138 2 14.0001 4.68628 14.0001 7.99997C14.0001 11.3137 11.3138 13.9999 8.00015 13.9999C5.96692 13.9999 4.1699 12.9886 3.0847 11.4415C2.41342 10.5517 2.00012 9.33793 2.00012 7.99994C2.00012 6.66154 2.41367 5.44741 3.08532 4.55756ZM8.00015 12.7499C7.69511 12.7499 7.39678 12.7212 7.10773 12.6662C8.60627 11.9927 9.68127 10.1578 9.68127 7.99994C9.68127 5.84209 8.60631 4.00728 7.10782 3.33368C7.39684 3.27875 7.69514 3.25 8.00015 3.25C10.6235 3.25 12.7501 5.37663 12.7501 7.99997C12.7501 10.6233 10.6235 12.7499 8.00015 12.7499Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Moon5am;
